<template>
  <UiButton
    :class="cn('size-7 rounded-full p-1 disabled:bg-transparent disabled:text-black/30', props.class)"
    variant="icon"
  >
    <LucideArrowLeft class="rtl:rotate-180" />
    <div class="sr-only">{{ $t("common.prev") }}</div>
  </UiButton>
</template>

<script setup lang="ts">
import { LucideArrowLeft } from "lucide-vue-next"

const props = defineProps<{
  class?: ClassValue
}>()
</script>
